// extracted by mini-css-extract-plugin
export default {"heading":"SchoolGroupsAttendancePage_heading__HKevA"};